export enum FlagType {
  cze = 'cze',
  svk = 'svk',
  pol = 'pol',
  usa = 'usa',
}
